import { Typography } from '@mui/material'
import { intl } from '../../../../i18n'
import { colorPalette } from '../../../style/colorPalette'
import { FontSize } from '../../../../styles/commonStyles'
import styled from '@mui/system/styled'

const SearchResultArea = styled('div')({
  display: 'flex',
  alignItems: 'center',
})
const SearchResult = styled(Typography)({
  color: colorPalette.monotone[10],
  fontWeight: 700,
  fontSize: FontSize.LARGE,
})

type CountSearchResultProps = {
  count: number | undefined
}

const CountSearchResult = ({ count }: CountSearchResultProps) => {
  return (
    <SearchResultArea>
      <Typography
        sx={{
          color: colorPalette.monotone[4],
          fontSize: FontSize.MEDIUM,
          marginTop: '1px',
          marginRight: '10px',
        }}
      >
        {intl.formatMessage({
          id: 'wbs.search.header.search.panel.result',
        })}
      </Typography>
      <SearchResult>
        {intl.formatMessage(
          { id: 'wbs.search.header.search.hits' },
          { hit: count }
        )}
      </SearchResult>
    </SearchResultArea>
  )
}

export default CountSearchResult
